import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { MemoryRouter, Route, Routes } from "react-router-dom";
import { FilterDialog } from "web/react/components/filter-redesign/filter-dialog/filter-dialog";
import { FiltersCategoriesScreen } from "web/react/components/filter-redesign/filters-categories-screen/filters-categories-screen";
import { FiltersFilterSearchScreen } from "web/react/components/filter-redesign/filters-filter-search-screen";
import { FiltersInitialScreen } from "web/react/components/filter-redesign/filters-inital-screen/filters-inital-screen";
import { FiltersSizesScreen } from "web/react/components/filter-redesign/filters-sizes-screen";
import { useFilterSync } from "web/react/hooks/filters";
import { useInitialReduxState } from "web/react/hooks/use-inital-redux-state/use-initial-redux-state";
import {
    setFiltersBaseUrl,
    setFiltersData,
    setFiltersFeedSortBy,
    setFiltersFeedUrl,
    setFiltersOnApplySortBy,
    setFiltersOnApplyUrl,
} from "web/redux/ducks/filters";
import { ReduxStoreState } from "web/redux/store";
import { FeedFiltersSerializer } from "web/types/serializers";
import { FiltersColorsScreen } from "./filters-colors-screen";
import { FiltersMaterialsScreen } from "./filters-materials-screen";

interface FilterRedesignProps {
    filters?: FeedFiltersSerializer;
    sortBy?: string;
}

export function FilterRedesign({ filters, sortBy }: FilterRedesignProps): JSX.Element {
    const isOpen = useSelector((state: ReduxStoreState) => state.feedSidebarReducer.open);

    useEffect(() => {
        if (isOpen) {
            document.body.classList.add("no-scroll");
        }
        return (): void => {
            document.body.classList.remove("no-scroll");
        };
    }, [isOpen]);

    useInitialReduxState([
        [setFiltersBaseUrl, filters?.feed_url],
        [setFiltersFeedUrl, filters?.feed_url],
        [setFiltersData, filters],
        [setFiltersFeedSortBy, sortBy || "recommended"],
        [setFiltersOnApplySortBy, sortBy || "recommended"],
        [setFiltersOnApplyUrl, filters?.feed_url],
    ]);
    const isDisabled = !useSelector(
        (state: ReduxStoreState) =>
            state?.filters?.ui?.url !== state?.filters?.ui?.onApplyUrl ||
            state?.filters?.ui?.sortBy !== state?.filters?.ui?.onApplySortBy
    );

    // do initial fetch
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { onApply, onReset, onClose } = useFilterSync();

    return (
        <MemoryRouter>
            <FilterDialog
                open={isOpen}
                onApply={onApply}
                onReset={onReset}
                onClose={onClose}
                isDisabled={isDisabled}
            >
                <Routes>
                    <Route index element={<FiltersInitialScreen />} />
                    <Route path="/colors" element={<FiltersColorsScreen />} />
                    <Route path="/materials" element={<FiltersMaterialsScreen />} />
                    <Route path="/sizes" element={<FiltersSizesScreen />} />
                    <Route
                        path="/designers"
                        element={<FiltersFilterSearchScreen facetName="designer_slug" />}
                    />
                    <Route
                        path="/stores"
                        element={<FiltersFilterSearchScreen facetName="retailer_slug" />}
                    />
                    <Route path="/categories" element={<FiltersCategoriesScreen />} />
                </Routes>
            </FilterDialog>
        </MemoryRouter>
    );
}
